module.exports = __webpack_public_path__ + "img/linkexterno.5fc4bdf6.svg";